import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { getMessageByIid } from '$logic/message'

const openedRoomPinnedMessagesView = (state: RootState) =>
  state?.main?.openedRoomPinnedMessages

export function useOpenedRoomPinnedMessagesIids(): number[] {
  return useSelector(openedRoomPinnedMessagesView)
}

export function usePinContentByIids(roomId: string, iids: number[], key = '') {
  const { loading, value: messages } = useAsyncFunction(
    () => Promise.all(iids.map(iid => getMessageByIid(roomId, iid))),
    [roomId, iids.join(''), key],
  )

  if (loading) return { loading: true }

  if (!iids?.length || !messages?.length) return { messages: null }

  const undeletedMessages = messages.filter(
    message => !message.patches?.deleted,
  )

  if (undeletedMessages.length < 1) return { messages: null }
  return { messages }
}
